import getters from './getters.js';
import mutations from './mutations.js';
import actions from './actions.js';

export default {
    namespaced: true,
    state() {
        return {
            gameOptions: {
                currentStep: 1,
                savedOptions: [],
                isUpdatingOption: false,
            },
            buildingPhases: {
                currentPhase: 0,
                savedMaterials: [],
                isUpdatingMaterial: false,
            },
            model: null,
            modelScreenshot: null,
            tooltips: {
                totalCount: 4,
                active: 1,
                seenAll: false,
                learnMoreActive: true,
                overviewTooltips: []
            },
            result: {
                id: null,
                rank: null,
                name: null,
                score: null
            }
        }
    },
    getters: getters,
    mutations: mutations,
    actions: actions,
}
